module.exports = __webpack_public_path__ + "static/img/btn2.9258f19.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/sky102/btn2.gif
// module id = ouUg
// module chunks = 1